import { IconButton, Card, Typography, Stack, Avatar, Box, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import DataTable from "examples/Tables/DataTable";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Visibility } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import ModalLabelBundle from "../Modal/ModalGroup";
import { getGroup } from "../../../../redux/group";

const columns = [
  { Header: "label", accessor: "label", width: "15%", align: "left" },
  { Header: "type", accessor: "type", align: "center" },
  { Header: "status", accessor: "status", align: "center" },
  { Header: "amount", accessor: "amount", align: "center" },
  { Header: "action", accessor: "action", align: "center" },
];
const TabGroup = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const shopDomain = useSelector((state) => state.shop.shopDomain);
  const groups = useSelector((state) => state.group.list);
  const [active, setActive] = useState(false);
  const [groupIndex, setGroupIndex] = useState(0);

  useEffect(() => {
    setLoading(true);
    if (shopDomain) {
      dispatch(getGroup(shopDomain)).then((res) => setLoading(false));
    }
  }, [shopDomain]);

  const handleCloseModal = useCallback(() => {
    setActive(false);
  }, []);

  const handleActiveModal = useCallback(
    (index) => () => {
      setActive(true);
      setGroupIndex(index);
    },
    []
  );

  // Memo hóa rows/table để identity không đổi khi mở modal,
  // tránh react-table reset pageIndex về 0 (autoResetPage).
  const rows = useMemo(
    () =>
      groups.map(({ name, type, status, label_ids, badge_ids }, index) => ({
        label: (
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography>{name}</Typography>
          </Stack>
        ),
        type: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={type}
              color={type == "label" ? "success" : "info"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={status ? "active" : "deactivate"}
              color={status ? "success" : "error"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        amount: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={(type == "label" ? label_ids?.length : badge_ids?.length) || "0"}
              color={"secondary"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        action: (
          <IconButton color="info" onClick={handleActiveModal(index)}>
            <Visibility />
          </IconButton>
        ),
      })),
    [groups, handleActiveModal]
  );

  const tableData = useMemo(() => ({ columns, rows }), [rows]);

  return (
    <>
      {shopDomain && (
        <Card sx={{ marginTop: 3 }}>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <Typography variant="h6" color="whitesmoke">
              Label Bundles
            </Typography>
          </MDBox>
          <MDBox pt={3}>
            {loading ? (
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <CircularProgress color="info" />
              </Box>
            ) : groups.length === 0 ? (
              <Typography>{`Don't have any Label bundle `}</Typography>
            ) : (
              <DataTable
                table={tableData}
                isSorted={false}
                entriesPerPage={false}
                showTotalEntries={false}
                noEndBorder
              ></DataTable>
            )}
          </MDBox>
          <ModalLabelBundle active={active} onClose={handleCloseModal} dataIndex={groupIndex} />
        </Card>
      )}
    </>
  );
};

export default TabGroup;
